const expandDescription = ( e ) => {
  const btn = e.currentTarget;
  const description = btn.parentNode.querySelector( '.featured-book__description-content' );
  btn.setAttribute( 'aria-expanded', 'true' );
  description.classList.add( 'is-expanded' );
};

document.addEventListener( 'DOMContentLoaded', () => {
  document.querySelectorAll( '.featured-book__read-more' ).forEach( ( btn ) => {
    btn.addEventListener( 'click', expandDescription );
  });
});
